const menunums = "1";   //导航索引

export default {
    menunums,
};